export default __webpack_public_path__ + "static/media/badge-ios.8c3b98f5.svg";